export default "/assets/7983035201522cea.svg"